export default "__VITE_ASSET__n3KjIobW__"